import React, { useMemo } from 'react';
import ProductCard from '../Components/ProductCards/ProductCard';
import Product from '../Types/Product';
import clsx from 'clsx';

interface ProductNoSliderProps {
  products: Product[];
  numPerRow: number;
  title?: string;
  footerLinkText?: string;
  footerLinkUrl?: string;
}

const ProductBlockNoSlider = (props: ProductNoSliderProps) => {
  const {
    products,
    numPerRow,
    title,
    footerLinkText,
    footerLinkUrl,
  } = props;

  let cellsClasses = useMemo(() => {
    switch (numPerRow) {
      case 1:
        return 'grid-cols-2';
      case 2:
        return 'grid-cols-2';
      case 3:
        return 'cells-3 md:grid-cols-3';
      case 4:
        return 'grid-cols-2 md:grid-cols-4';
      case 5:
        return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5';
      case 6:
        return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6';
    }
  }, [numPerRow]);

  return (
    <>
      <div className="flex justify-between mb-6 relative z-10">
        {title && title != '' && (
          <h2 className="leading-tight uppercase font-satoshi font-satoshi-bold">
            {title}
          </h2>
        )}
        {footerLinkText &&
          footerLinkText != '' &&
          footerLinkUrl &&
          footerLinkUrl != '' && (
            <button
              onClick={() => (window.location.href = footerLinkUrl)}
              className="btn btn--medium btn--outlined"
            >
              {footerLinkText}
            </button>
          )}
      </div>
      <div className={clsx('gap-1 grid', cellsClasses)}>
        {products.map((product, idx) => (
          <ProductCard
            key={product.id + 'noslide' + idx}
            product={product}
          />
        ))}
      </div>
    </>
  );
};

export default ProductBlockNoSlider;
